<script>
import ELEMENT from 'element-ui';
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  componentName: 'ElDropdown',
  mixins: [ELEMENT.utils.Emitter],
  props: {
    size: {
      type: String,
      default: 'small',
    },
    icon: {
      type: String,
      default: 'el-icon-more',
    },
    text: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'default',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'bottom-end',
    },
  },
  mounted() {
    this.$on('menu-item-click', this.handleMenuItemClick);
  },
  methods: {
    handleMenuItemClick(command, instance) {
      if (!this.disabled) {
        this.$emit('command', command, instance);
        this.$refs.dropdown.handleClose();
      }
    },
  },
  beforeDestroy() {
    this.$off();
  },
});
</script>
<template>
  <cly-dropdown
    ref="dropdown"
    class="cly-vue-more-options"
    :placement="placement"
    :disabled="disabled"
    v-on="$listeners"
  >
    <template #trigger>
      <slot name="trigger">
        <el-button
          :size="size"
          :icon="icon"
          :type="type"
        >
          <span v-if="text">{{ text }}</span>
        </el-button>
      </slot>
    </template>
    <template #default>
      <slot />
    </template>
  </cly-dropdown>
</template>
